"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _defineProperty = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inheritsLoose"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _sha = _interopRequireDefault(require("crypto-js/sha1"));

var _eventemitter = _interopRequireDefault(require("eventemitter3"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _constant = require("../_utils/constant");

/*
 * @Author: lijianzhang
 * @Date: 2018-10-28 20:31:24
 * @Last Modified by: lijianzhang
 * @Last Modified time: 2019-02-14 18:21:29
 */
// udesk 配置信息
var imUserKey = '5f4ccb0eae5588fe36c8f8c797bd83fe';
var code = '2fc6j4ag';
var link = 'https://ttxsapp.udesk.cn/im_client/?web_plugin_id=52568&group_id=89541';
var windowloaded = false;
/**
 * 确保 udesk iframe 在 页面 load 之后加载
 *
 * @returns
 */

function onWindowLoad() {
  return new _promise.default(function (resolve) {
    if (windowloaded) return resolve();

    function onLoad() {
      windowloaded = true;
      window.removeEventListener('load', onload);
      resolve();
    }

    if (window) {
      window.addEventListener('load', onLoad);
    }
  });
}

onWindowLoad();
/**
 * 封装了 udesk 的使用方式
 *
 * @class Udesk
 * @extends {Event}
 */

var Udesk =
/*#__PURE__*/
function (_Event) {
  (0, _inheritsLoose2.default)(Udesk, _Event);

  function Udesk() {
    var _this;

    _this = _Event.call(this) || this; // 当前应该显示的文本, 会根据客服是否上线而变化

    _this.label = ''; // 唯独消息的数目

    _this.unread = 0;
    _this.config = null;
    _this.panelStyle = {};
    _this.firstShow = true;
    _this.isShow = false;
    _this.lastConfig = null;
    _this.setConfig = (0, _debounce.default)(_this._setConfig.bind((0, _assertThisInitialized2.default)(_this)), 1000, {
      trailing: true
    });
    return _this;
  }
  /**
   * 获取随机字符串
   */


  var _proto = Udesk.prototype;

  _proto.getNonce = function getNonce(num) {
    var s = '';

    while (s.length < num) {
      var n = Math.floor(Math.random() * 62);
      if (n < 10) s += n;else if (n < 36) s += String.fromCharCode(n + 55); // AZ
      else s += String.fromCharCode(n + 61); // az
    }

    return s;
  }
  /**
   *
   *
   * @param {} config
   * @param string config.code - udesk配置信息
   * @param string config.link - udesk配置信息
   * @param string config.onlineText - 客服在线显示文本，默认为 **udesk管理台配置文案**
   * @param string config.offlineText - 客服在线显示文本，默认为 **客服离线显示文本 **udesk管理台配置文案**
   * @param {[string]: string} config.css  style - 按钮样式
   * @param {}  config.panel - 聊天面板
   * @param {} config.customer  - 客户信息 [参考](http://www.udesk.cn/doc/thirdparty/webim/#_11)
   * @param {title: string; url: string; image: string, <自定义参数>: string}  config.product - 客户信息 [参考](http://www.udesk.cn/doc/thirdparty/webim/#_11)
   */
  ;

  _proto._setConfig = function _setConfig(config) {
    var _this2 = this;

    if (config === void 0) {
      config = {};
    }

    if ((0, _constant.isSSR)()) return;
    if ((0, _isEqual.default)(this.lastConfig, config)) return; // 避免重复修改

    this.lastConfig = config;
    var self = this;
    var finalConfig = (0, _merge.default)({
      code,
      link,
      css: {
        display: 'none'
      },
      customer: {},
      panel: {
        css: this.panelStyle,

        onToggle(_ref) {
          var visible = _ref.visible;

          // 不默认打开聊天面板
          if (visible && !self.isShow) {
            self.hide();
          }

          if (!visible) {
            self.isShow = false;
          }

          self.emit('toggle', visible);
        }

      },

      onUnread(_ref2) {
        var count = _ref2.count;
        self.unread = count;
        self.emit('onunread', count);
      }

    }, config);

    if (finalConfig.customer && finalConfig.customer.web_token) {
      var customer = (0, _assign.default)({}, config.customer);
      var timestamp = (0, _now.default)();
      var nonce = this.getNonce(14); // signature 固定格式

      var signature = (0, _sha.default)("nonce=" + nonce + "&timestamp=" + timestamp + "&web_token=" + customer.web_token + "&" + imUserKey).toString().toUpperCase();
      customer.nonce = nonce;
      customer.timestamp = timestamp;
      customer.signature = signature;
      finalConfig.customer = customer;
    }

    this.config = finalConfig;
    onWindowLoad().then(function () {
      return _this2.runUdeskScript();
    });
  };

  _proto.runUdeskScript = function runUdeskScript() {
    if (window.ud) {
      var udeskIframe = document.getElementById('udesk_iframe');

      if (udeskIframe && !this.__firstSetIframeSrc) {
        this.__firstSetIframeSrc = true;
        /**
         * 为什么特意对iframe.src处理
         * 原因： 重新修改udesk配置的时候，udesk内部会修改iframe的地址，会使浏览器的历史记录存入了udesk的更变地址，从而导致浏览器回退不正常
         * 要想要避免被存入浏览记录，那么在设置iframe的src的时候， iframe不能存在于dom树上， 而且udesk脚本，内部持有这个iframe
         * 所以不可以通过新建iframe的方式， 那么就让udesk在修改src前先让iframe脱离dom， 修改完后再插入dom中
         */

        (0, _defineProperty.default)(udeskIframe, 'src', {
          configurable: true,

          set(value) {
            var parentElement = udeskIframe.parentElement;
            udeskIframe.setAttribute('src', value);
            parentElement.appendChild(udeskIframe);
          },

          get() {
            return udeskIframe.attributes.src;
          }

        });
      }
    }

    if (!window.ud) {
      (function (a, h, c, b, f, g) {
        a['UdeskApiObject'] = f;

        a[f] = a[f] || function () {
          (a[f].d = a[f].d || []).push(arguments);
        };

        g = h.createElement(c);
        g.async = 1;
        g.charset = 'utf8';
        g.src = b;
        c = h.getElementsByTagName(c)[0];
        c.parentNode.insertBefore(g, c);
      })(window, document, 'script', '//assetscli.udesk.cn/im_client/js/udeskApi.js', 'ud');
    }

    window.ud(this.config);

    if (this.config.panel && this.config.panel.css) {
      this.setPanelStyle(this.config.panel.css);
    }

    this.wachUdeskLabel();
  };

  _proto.setPanelStyle = function setPanelStyle(style) {
    var panel = document.getElementById('udesk_panel');

    if (panel) {
      (0, _keys.default)(style).forEach(function (k) {
        panel.style[k] = style[k];
      });
    }
  }
  /**
   * 显示聊天面板
   *
   * @memberof Udesk
   */
  ;

  _proto.show = function show() {
    if (!window.ud) return;

    if (this.firstShow) {
      if (!this.config) throw new Error('udesk 没有配置， 请执行 setConfig 配置');
      window.ud(this.config);
      this.firstShow = false;
    }

    this.isShow = true;
    this.unread = 0;
    this.emit('onunread', 0);
    window.ud.showPanel();
  }
  /**
   * 隐藏聊天面板
   */
  ;

  _proto.hide = function hide() {
    if (window.ud) window.ud.hidePanel();
  }
  /**
   * 开关切换
   */
  ;

  _proto.toggle = function toggle() {
    this.isShow ? this.hide() : this.show();
  };

  _proto.getLabel = function getLabel() {
    this.btn = document.getElementById('udesk_btn');

    if (this.btn) {
      this.btn.style.display = 'none';
      var label = this.label;
      this.label = document.getElementById('udesk_btn_text').innerHTML;

      if (this.label !== label) {
        this.emit('onlabel', this.label);
      }
    }
  };

  _proto.wachUdeskLabel = function wachUdeskLabel() {
    var _this3 = this;

    this.timer = setTimeout(function () {
      _this3.getLabel();

      _this3.wachUdeskLabel();
    }, 1000);
  };

  _proto.destroy = function destroy() {
    clearTimeout(this.timer);
  };

  return Udesk;
}(_eventemitter.default);

var _default = new Udesk();

exports.default = _default;